import { FailedToLoad } from '@ms/yammer-error-components';
import { useTranslations } from '@ms/yammer-i18n-react';
import ErrorStrings from '@ms/yammer-strings/dist/Error';
import type { FC } from 'react';
import React from 'react';

const UnlicensedUserError: FC = () => {
  const t = useTranslations(ErrorStrings);

  return <FailedToLoad title={t.bootstrapErrorTitleYammer()} error={t.bootstrapErrorUnlicensedUserYammer()} />;
};

export default UnlicensedUserError;
